import "./ReportView.css";

const NARRATIVES = [
  ["executive_summary", "Executive Summary"], ["parish_identity_profile", "Parish Identity Profile"],
  ["mission_analysis", "Mission Analysis"], ["liturgical_identity", "Liturgical Identity"],
  ["worship_intelligence", "Worship Intelligence"], ["music_ministry_intelligence", "Music Ministry Intelligence"],
  ["leadership_analysis", "Leadership Analysis"], ["congregational_analysis", "Congregational Analysis"],
  ["community_analysis", "Community Analysis"], ["operational_analysis", "Operational Analysis"],
  ["financial_risk_observations", "Financial & Risk Observations"], ["volunteer_capacity", "Volunteer Capacity"],
];
const LISTS = [
  ["growth_opportunities", "Growth Opportunities"], ["risk_factors", "Risk Factors"],
  ["quick_wins", "Quick Wins"], ["recommendations", "Recommendations"], ["five_year_vision", "Five-Year Vision"],
];

export default function ReportView({ report, meta = {} }) {
  if (!report) return null;
  const sc = report.scorecard || {};
  const swot = report.swot || {};

  return (
    <div className="report-print-area rv">
      <div className="report-print-brand">
        <img src="/brand/li-logo-sm.png" alt="Liturgical Intelligence™" />
        <div className="rpb-t"><b>Parish Intelligence Report</b><span>Liturgical Intelligence™ · Ordo AI™</span></div>
      </div>

      <div className="rv-head">
        <div>
          <h1 data-testid="report-title">{meta.parish_name || "Parish Intelligence Report"}</h1>
          {meta.created_at && <div className="rv-date">{new Date(meta.created_at).toLocaleDateString()}</div>}
        </div>
        <button className="rv-pdf report-no-print" onClick={() => window.print()} data-testid="download-pdf-btn">
          ⬇ Download PDF
        </button>
      </div>

      {(sc.overall_score != null || (sc.categories || []).length > 0) && (
        <div className="rv-score rv-sec">
          <div className="rv-gauge"><span>{sc.overall_score ?? "—"}</span><small>PI Score</small></div>
          <div className="rv-cats">
            {sc.overall_grade && <div className="rv-grade">Grade {sc.overall_grade}</div>}
            <div className="rv-cat-grid">
              {(sc.categories || []).map((c) => (
                <div className="rv-cat" key={c.name}>
                  <div className="cn">{c.name}</div>
                  <div className="cb"><i style={{ width: `${c.score}%` }} /></div>
                  <div className="cv">{c.score}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {NARRATIVES.map(([k, t]) => report[k] ? (
        <div className="rv-sec" key={k}><h2>{t}</h2><p>{report[k]}</p></div>
      ) : null)}

      {(swot.strengths || swot.weaknesses || swot.opportunities || swot.threats) && (
        <div className="rv-sec"><h2>SWOT Analysis</h2>
          <div className="rv-swot">
            {[["strengths", "Strengths"], ["weaknesses", "Weaknesses"], ["opportunities", "Opportunities"], ["threats", "Threats"]].map(([k, t]) => (
              <div className="rv-swot-box" key={k}><h4>{t}</h4>
                <ul>{(swot[k] || []).map((x, i) => <li key={i}>{x}</li>)}</ul>
              </div>
            ))}
          </div>
        </div>
      )}

      {LISTS.map(([k, t]) => (report[k] || []).length ? (
        <div className="rv-sec" key={k}><h2>{t}</h2>
          <ul>{report[k].map((x, i) => <li key={i}>{x}</li>)}</ul>
        </div>
      ) : null)}

      {(report.ninety_day_action_plan || []).length > 0 && (
        <div className="rv-sec"><h2>90-Day Action Plan</h2>
          {report.ninety_day_action_plan.map((a, i) => (
            <div className="rv-action" key={i}><b>{a.title}</b><span>{a.detail}</span></div>
          ))}
        </div>
      )}

      {(report.one_year_roadmap || []).length > 0 && (
        <div className="rv-sec"><h2>One-Year Roadmap</h2>
          {report.one_year_roadmap.map((r, i) => (
            <div className="rv-action" key={i}><b>{r.period}</b><span>{r.focus}</span></div>
          ))}
        </div>
      )}

      {report.final_executive_summary && (
        <div className="rv-sec"><h2>Final Executive Summary</h2><p>{report.final_executive_summary}</p></div>
      )}
    </div>
  );
}
